<template>
  <div class="contract-detail-bd" v-if="funcView.contract_detail">
    <div class="container">
      <h3 class="title">{{ $t('contract_detail_he_tong_bian_hao') }} {{ contractDetail.contractNo }}</h3>
      <p class="status flex flex-h-center">
        {{ $t('contract_detail_htzt') }}
        <!-- {{ bizClassType === 'contract' ? '合同状态：' : '订单状态：' }} -->
        <span class="point">
          <i></i>
          {{ getDicValue('crm_contract_biz_state', contractDetail.bizState) }}
        </span>
        <span class="icon icon-xiazai download" v-if="isHasContractFile && funcView.contract_download" @click="download(contractDetail)"></span>
      </p>
      <ul class="introduction">
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contract_detail_jfsqdb') }}</p>
            <p class="name" :title="contractDetail.partyAName">{{ contractDetail.partyAName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contract_detail_yi_fang') }}</p>
            <p class="name" :title="contractDetail.customerName">{{ contractDetail.customerName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contract_detail_shou_hou_gong_si') }}</p>
            <p class="name" :title="contractDetail.afterServiceName">{{ contractDetail.afterServiceName }}</p>
          </div>
        </li>
        <li class="flex flex-h-center">
          <i class="icon icon-gongsi"></i>
          <div class="text">
            <p class="key">{{ $t('contract_detail_htsbs') }}</p>
            <p class="name" :title="contractDetail.contractDeviceNum">{{ contractDetail.contractDeviceNum }}</p>
          </div>
        </li>
      </ul>
      <div class="info">
        <p class="line">
          {{ $t('contract_detail_he_tong_xin_xi') }}
          <span class="action" @click="showInfo = !showInfo">
            {{ showInfo ? $t('contract_detail_shou_qi') : $t('contract_detail_zhan_kai') }}
            <i class="icon" :class="{ 'icon-shouhui': showInfo, 'icon-zhankai': !showInfo }"></i>
          </span>
        </p>
        <ul class="info-box" v-show="showInfo">
          <li>
            <h4>{{ $t('contract_detail_ji_ben_xin_xi') }}</h4>
            <p class="key">
              {{ $t('contract_detail_sghth') }}:
              <span class="val" :title="contractDetail.contractDeviceNum">{{ contractDetail.customContractNo }}</span>
            </p>
            <p class="key">
              {{ bizClassType === 'contract' ? $t('contract_detail_he_tong_lei_xing') : $t('contract_detail_ddlx') }} {{':'}}
              <span class="val">{{ getDicValue('crm_contract_type', contractDetail.bizClass) }}</span>
            </p>
            <p class="key" v-if=" bizClassType === 'contract'">
              {{ $t('contract_detail_he_tong_qi_xian') }}:
              <span class="val">{{ contractDetail.signingDuration }}({{ $t('contract_detail_yue') }})</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_qian_ding_ri_qi') }}:
              <span class="val">{{ $momentLocal(contractDetail.signingDate,'YYYY-MM-DD')   || '-' }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_xiang_mu') }}:
              <span class="val" :title="contractDetail.locationName">{{ contractDetail.locationName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_xmfzr') }}:
              <span class="val" :title="contractDetail.projectContactName">{{ contractDetail.projectContactName }} {{ contractDetail.projectContactPhone }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_shi_yong_di_zhi') }}:
              <span class="val" :title="contractDetail.useAddress">{{ contractDetail.useAddress }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contract_detail_jfsqdb_1') }}</h4>
            <p class="key">
              {{ $t('contract_detail_ming_cheng') }}:
              <span class="val" :title="contractDetail.partyAName">{{ contractDetail.partyAName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_ye_wu_ren_yuan') }}:
              <span class="val" :title="contractDetail.salesman">{{ contractDetail.salesman }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_ywrydh') }}:
              <span class="val" :title="contractDetail.salesmanPhone">{{ contractDetail.salesmanPhone }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contract_detail_yi_fang_1') }}</h4>
            <p class="key">
              {{ $t('contract_detail_ming_cheng_1') }}:
              <span class="val" :title="contractDetail.customerName">{{ contractDetail.customerName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_qian_shu_ren') }}:
              <span class="val" :title="contractDetail.signerName">{{ contractDetail.signerName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_qsrdh') }}:
              <span class="val" :title="contractDetail.signerPhone">{{ contractDetail.signerPhone }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_gong_si_di_zhi') }}:
              <span class="val" :title="contractDetail.customerAddress">{{ contractDetail.customerAddress }}</span>
            </p>
          </li>
          <li>
            <h4>{{ $t('contract_detail_shou_hou_gong_si_1') }}</h4>
            <p class="key">
              {{ $t('contract_detail_ming_cheng_2') }}:
              <span class="val" :title="contractDetail.afterServiceName">{{ contractDetail.afterServiceName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_fu_zhai_ren') }}:
              <span class="val" :title="contractDetail.technicianName">{{ contractDetail.technicianName }}</span>
            </p>
            <p class="key">
              {{ $t('contract_detail_fzrdh') }}:
              <span class="val" :title="contractDetail.technicianPhone">{{ contractDetail.technicianPhone }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="device">
        <p class="line">{{ $t('contract_detail_he_tong_she_bei') }}</p>
        <div class="tab-box">
          <!-- {{formSearch.deviceState}} -->
          <!-- {{tableColumn}} -->
          <el-tabs v-model="formSearch.deviceState" @tab-click="onPageChange({ page: 1 })" v-if="stateCodeDic.zlz">
            <el-tab-pane :label="`${$t('contract_detail_dai_fa_huo')} (${countDetail[stateCodeDic.dfh] || 0})`" :name="stateCodeDic.dfh"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_dai_qi_zu')} (${+countDetail[stateCodeDic.ztz] || 0 + countDetail[stateCodeDic.dqz] || 0})`" :name="`${stateCodeDic.ztz},${stateCodeDic.dqz}`"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_zu_lin_zhong')} (${countDetail[stateCodeDic.zlz] || 0})`" :name="stateCodeDic.zlz"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_yi_zan_ting')} (${countDetail[stateCodeDic.yzt] || 0})`" :name="stateCodeDic.yzt"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_yi_geng_huan')} (${countDetail[stateCodeDic.ygh] || 0})`" :name="stateCodeDic.ygh"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_yi_wei_yue')} (${countDetail[stateCodeDic.ywy] || 0})`" :name="stateCodeDic.ywy"></el-tab-pane>
            <el-tab-pane :label="`${$t('contract_detail_yi_dao_qi')} (${countDetail[stateCodeDic.ydq] || 0})`" :name="stateCodeDic.ydq"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="table-bd">
          <ul class="table-head">
            <li class="product"></li>
            <li v-for="column in tableColumn" :key="column.key" :style="{ flex: column.flex }">
              <span :title="column.name">{{ column.name }}</span>
            </li>
          </ul>
          <ul class="table-body">
            <template v-if="tableList.length > 0">
              <li class="li" v-for="item in tableList" :key="item.siteId">
                <ul class="content">
                  <li class="product">
                    <!-- <img src="http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/dev/isc/product/B1EDF6B4822B46F3BB19820DFC48B22F.jpg" /> -->
                    <img v-if="getAttachUrl(item)" :src="getAttachUrl(item)" alt />
                  </li>

                  <li v-for="column in tableColumn" :key="column.key" :style="{ flex: column.flex }">
                    <span v-if="column.code" :title="getDicValue(column.code, item[column.key]) || '-'">{{ getDicValue(column.code, item[column.key])|| '-' }}</span>
                    <span v-else-if="column.format&&column.format==='date'" :title="$momentLocal(item[column.key],'YYYY-MM-DD')  || '-'">{{ $momentLocal(item[column.key],'YYYY-MM-DD') || '-' }}</span>
                    <span v-else-if="column.key&&column.key==='rentalTerm'" :title="`${item[column.key]} ${getDicValue(column.unitCode,item[column.unitKey])}`">{{ item[column.key] || '-' }} {{ getDicValue(column.unitCode,item[column.unitKey])|| '-'  }}</span>
                    <span v-else :title="item[column.key] || '-'">{{ item[column.key] || '-' }}</span>
                  </li>
                </ul>
              </li>
            </template>
            <template v-else>
              <li class="no-data">{{ $t('com_no_data') }}</li>
            </template>
          </ul>
        </div>
        <div class="table-footer">
          <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';

// i18n-lang-component
// contract_detail_he_tong_bian_hao: 合同编号// contract_detail_htzt: 合同状态// contract_detail_jfsqdb: 甲方授权代表// contract_detail_yi_fang: 乙方// contract_detail_shou_hou_gong_si: 售后公司// contract_detail_htsbs: 合同设备数// contract_detail_he_tong_xin_xi: 合同信息// contract_detail_shou_qi: 收起// contract_detail_zhan_kai: 展开// contract_detail_ji_ben_xin_xi: 基本信息// contract_detail_sghth: 手工合同号// contract_detail_he_tong_lei_xing: 合同类型// contract_detail_ddlx: 订单类型// contract_detail_he_tong_qi_xian: 合同期限// contract_detail_yue: 月// contract_detail_qian_ding_ri_qi: 签订日期// contract_detail_xiang_mu: 项目// contract_detail_xmfzr: 项目负责人// contract_detail_shi_yong_di_zhi: 使用地址// contract_detail_jfsqdb_1: 甲方授权代表// contract_detail_ming_cheng: 名称// contract_detail_ye_wu_ren_yuan: 业务人员// contract_detail_ywrydh: 业务人员电话// contract_detail_yi_fang_1: 乙方// contract_detail_ming_cheng_1: 名称// contract_detail_qian_shu_ren: 签署人// contract_detail_qsrdh: 签署人电话// contract_detail_gong_si_di_zhi: 公司地址// contract_detail_shou_hou_gong_si_1: 售后公司// contract_detail_ming_cheng_2: 名称// contract_detail_fu_zhai_ren: 负责人// contract_detail_fzrdh: 负责人电话// contract_detail_he_tong_she_bei: 合同设备// contract_detail_dai_fa_huo: 待发货// contract_detail_dai_qi_zu: 待启租// contract_detail_zu_lin_zhong: 租赁中// contract_detail_yi_zan_ting: 已暂停// contract_detail_yi_geng_huan: 已更换// contract_detail_yi_wei_yue: 已违约// contract_detail_yi_dao_qi: 已到期// contract_detail_she_bei_hao: 设备号// contract_detail_cpxh: 产品型号// contract_detail_she_bei_hao_1: 设备号// contract_detail_ji_shen_hao: 机身号// contract_detail_cpxh_1: 产品型号// contract_detail_fa_huo_shi_jian: 发货时间// contract_detail_shou_huo_ren: 收货人// contract_detail_shsj: 收货时间// contract_detail_she_bei_hao_2: 设备号// contract_detail_ji_shen_hao_1: 机身号// contract_detail_cpxh_2: 产品型号// contract_detail_qi_zu_ri_qi: 启租日期// contract_detail_ztts: 暂停天数// contract_detail_dao_qi_ri_qi: 到期日期// contract_detail_zu_jin_dan_jia: 租金单价// contract_detail_zu_lin_shi_chang: 租赁时长// contract_detail_zhi_fu_zhou_qi: 支付周期// contract_detail_ya_jin: 押金// contract_detail_shou_hou_gong_si_2: 售后公司// contract_detail_qi_zu_ren: 启租人// contract_detail_she_bei_hao_3: 设备号// contract_detail_ji_shen_hao_2: 机身号// contract_detail_cpxh_3: 产品型号// contract_detail_qi_zu_ri_qi_1: 启租日期// contract_detail_ztsj: 暂停时间// contract_detail_zu_jin_dan_jia_1: 租金单价// contract_detail_zu_lin_shi_chang_1: 租赁时长// contract_detail_zhi_fu_zhou_qi_1: 支付周期// contract_detail_ya_jin_1: 押金// contract_detail_shou_hou_gong_si_3: 售后公司// contract_detail_she_bei_hao_4: 设备号// contract_detail_ji_shen_hao_3: 机身号// contract_detail_cpxh_4: 产品型号// contract_detail_qi_zu_ri_qi_2: 启租日期// contract_detail_ghsj: 更换时间// contract_detail_zu_jin_dan_jia_2: 租金单价// contract_detail_zu_lin_shi_chang_2: 租赁时长// contract_detail_zhi_fu_zhou_qi_2: 支付周期// contract_detail_ya_jin_2: 押金// contract_detail_she_bei_hao_5: 设备号// contract_detail_ji_shen_hao_4: 机身号// contract_detail_cpxh_5: 产品型号// contract_detail_qi_zu_ri_qi_3: 启租日期// contract_detail_wei_yue_shi_jian: 违约时间// contract_detail_zu_jin_dan_jia_3: 租金单价// contract_detail_zu_lin_shi_chang_3: 租赁时长// contract_detail_zhi_fu_zhou_qi_3: 支付周期// contract_detail_ya_jin_3: 押金// contract_detail_she_bei_hao_6: 设备号// contract_detail_ji_shen_hao_5: 机身号// contract_detail_cpxh_6: 产品型号// contract_detail_qi_zu_ri_qi_4: 启租日期// contract_detail_dao_qi_shi_jian: 到期时间// contract_detail_zu_jin_dan_jia_4: 租金单价// contract_detail_zu_lin_shi_chang_4: 租赁时长// contract_detail_zhi_fu_zhou_qi_4: 支付周期// contract_detail_ya_jin_4: 押金// contract_detail_dzhtqs: 电子合同缺失// contract_detail_htfjqs: 合同附件缺失

export default {
  name: 'contractDetail',
  components: {},
  computed: {
    // 根据不同状态返回不同显示的列
    // 1. 待发货（待发货，在库中）：设备号，产品型号
    // 2. 待启租（在途中，待启租）：设备号，机身号，产品型号，发货时间，收货人，收货时间
    // 3. 租赁中：设备号，机身号 bodyNum，产品型号，启租日期，暂停天数，到期日期，租金单价，租赁时长，支付周期，押金，售后公司，启租人
    // 4. 已暂停：设备号，机身号，产品型号，启租日期，暂停时间，租金单价，租赁时长，支付周期，押金，售后公司
    // 5. 已更换：设备号，机身号，产品型号，启租日期，更换时间，租金单价，租赁时长，支付周期，押金
    // 6. 已违约：设备号，机身号，产品型号，启租日期，违约时间，租金单价，租赁时长，支付周期，押金
    // 7. 已到期：设备号，机身号，产品型号，启租日期，到期时间，租金单价，租赁时长，支付周期，押金
    tableColumn() {
      let arr = [];
      switch (this.formSearch.deviceState) {
        // 待发货
        case this.stateCodeDic.dfh:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao'),
              key: 'deviceNo',
              flex: 2
            },
            {
              name: this.$t('contract_detail_cpxh'),
              key: 'productCode',
              flex: 2
            }
          ];
          break;
        // 待启租
        case `${this.stateCodeDic.ztz},${this.stateCodeDic.dqz}`:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_1'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_1'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_fa_huo_shi_jian'),
              key: 'shipmentTime',
              flex: 2,
              format: 'time'
            },
            {
              name: this.$t('contract_detail_shou_huo_ren'),
              key: 'deliveryUser',
              flex: 2
            },
            {
              name: this.$t('contract_detail_shsj'),
              key: 'deliveryTime',
              flex: 2,
              format: 'time'
            }
          ];
          break;
        // 租赁中
        case this.stateCodeDic.zlz:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_2'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao_1'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_2'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_qi_zu_ri_qi'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contract_detail_ztts'),
              key: 'pauseDuration',
              flex: 1
            },
            {
              name: this.$t('contract_detail_dao_qi_ri_qi'),
              key: 'endRentDate',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contract_detail_zu_jin_dan_jia'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contract_detail_zu_lin_shi_chang'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contract_detail_zhi_fu_zhou_qi'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contract_detail_ya_jin'),
              key: 'depositFee',
              flex: 1
            },
            // {
            //   name: '到期日期',
            //   key: 'endRentDate',
            //   flex: 2
            // },
            {
              name: this.$t('contract_detail_shou_hou_gong_si_2'),
              key: 'afterServiceName',
              flex: 4
            },
            {
              name: this.$t('contract_detail_qi_zu_ren'),
              key: 'rentalUser',
              flex: 2
            }
          ];
          break;
        // 已暂停
        case this.stateCodeDic.yzt:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_3'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao_2'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_3'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_qi_zu_ri_qi_1'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contract_detail_ztsj'),
              key: 'changeDate1',
              flex: 2
            },
            {
              name: this.$t('contract_detail_zu_jin_dan_jia_1'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contract_detail_zu_lin_shi_chang_1'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contract_detail_zhi_fu_zhou_qi_1'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contract_detail_ya_jin_1'),
              key: 'depositFee',
              flex: 2
            },
            {
              name: this.$t('contract_detail_shou_hou_gong_si_3'),
              key: 'afterServiceName',
              flex: 4
            }
          ];
          break;
        // 已更换
        case this.stateCodeDic.ygh:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_4'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao_3'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_4'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_qi_zu_ri_qi_2'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contract_detail_ghsj'),
              key: 'changeDate',
              flex: 2,
              format: 'time'
            },
            {
              name: this.$t('contract_detail_zu_jin_dan_jia_2'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contract_detail_zu_lin_shi_chang_2'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contract_detail_zhi_fu_zhou_qi_2'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contract_detail_ya_jin_2'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;
        // 已违约
        case this.stateCodeDic.ywy:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_5'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao_4'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_5'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_qi_zu_ri_qi_3'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'time'
            },
            {
              name: this.$t('contract_detail_wei_yue_shi_jian'),
              key: 'breakTime',
              flex: 2,
              format: 'time'
            },
            {
              name: this.$t('contract_detail_zu_jin_dan_jia_3'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contract_detail_zu_lin_shi_chang_3'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contract_detail_zhi_fu_zhou_qi_3'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contract_detail_ya_jin_3'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;
        // 已到期
        case this.stateCodeDic.ydq:
          arr = [
            {
              name: this.$t('contract_detail_she_bei_hao_6'),
              key: 'deviceNo',
              flex: 1
            },
            {
              name: this.$t('contract_detail_ji_shen_hao_5'),
              key: 'bodyNum',
              flex: 1
            },
            {
              name: this.$t('contract_detail_cpxh_6'),
              key: 'productCode',
              flex: 1
            },
            {
              name: this.$t('contract_detail_qi_zu_ri_qi_4'),
              key: 'rentalStartTime',
              flex: 2,
              format: 'date'
            },
            {
              name: this.$t('contract_detail_dao_qi_shi_jian'),
              key: 'endRentDate',
              flex: 2,
              format: 'time'
            },
            {
              name: this.$t('contract_detail_zu_jin_dan_jia_4'),
              key: 'unitPrice',
              flex: 1
            },
            {
              name: this.$t('contract_detail_zu_lin_shi_chang_4'),
              key: 'rentalTerm',
              flex: 2,
              unitKey: 'rentalTermUnit',
              unitCode: 'rental_term_unit'
            },
            {
              name: this.$t('contract_detail_zhi_fu_zhou_qi_4'),
              key: 'paymentPeriod',
              flex: 2,
              code: 'crm_payment_period'
            },
            {
              name: this.$t('contract_detail_ya_jin_4'),
              key: 'depositFee',
              flex: 2
            }
          ];
          break;

        default:
          arr = [];
      }

      return arr;
    }
  },
  data() {
    return {
      showInfo: true,
      tableList: [],
      stateCodeDic: {},
      formSearch: {
        deviceState: '',
        bizId: '',
        search: '',
        pageNum: 1,
        pageSize: 50
      },
      totalRows: null,
      contractId: '',
      contractClass: '',
      approveType: '',
      contractDetail: {},
      countDetail: {},
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
      isHasContractFile: false
    };
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_contractDetail');
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass');
    this.formSearch.bizId = this.contractId;
    if (this.contractBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(`${this.contractClass}`)) {
      this.bizClassType = 'order';
    }
    this.getFuncView('/rent/contract');
    this.getContractDetail();
    this.getTableCount();
  },
  methods: {
    // 获取合同详情
    getContractDetail: function () {
      this.$getJSON(apis.contractInfo, {
        bizId: this.contractId,
        bizClass: this.contractClass
      }).then((res) => {
        const detail = res.data;
        this.contractDetail = detail;
        this.contractDeviceNum = detail.contractDeviceNum || 0;
        this.loadContractFile(this.contractDetail);
      });
    },
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.ContractDevicePage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.breakTime = item.endRentDate;
        });
        if (list.length > 0) {
          this.formatAttachList(list, 'productCodeId', 'dms.product.icon')
            .then((result) => {
              this.tableList = result;
            })
            .catch(() => {
              this.tableList = list;
            });
        } else {
          this.tableList = list;
        }
        this.totalRows = res.data.total;
      });
    },
    // 获取表格数据数量
    getTableCount: function () {
      this.$getJSON(apis.ContractDeviceCount, { bizId: this.contractId }).then((res) => {
        this.countDetail = res.data || {};
        // 默认第一个待发货 其他状态有设备就默认是其他状态
        let defaultState = 10;
        Object.keys(res.data).some((key) => {
          if (res.data[key] > 0) {
            defaultState = key;
            // 取一个之后退出循环
            return true;
          }
          return false;
        });
        this.getDictionary('order_device_biz_state', (data) => {
          this.stateCodeDic = this.$listTransObject(data.order_device_biz_state, 'code', 'value');
          // 在途中 待启租 合并一起用
          if (`${defaultState}` === '15' || `${defaultState}` === '21') {
            this.formSearch.deviceState = `${this.stateCodeDic.ztz},${this.stateCodeDic.dqz}`;
          } else {
            this.formSearch.deviceState = defaultState;
          }
          this.getTableList();
        });

      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    loadContractFile(contractDetail) {
      if (`${contractDetail.signingMethod}` === '1') {
        // 电子合同
        // econtractAttachment: "http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/bestSign/2021-07-26/162726616701000001.pdf"
        // 接口返回字段定义为eContractAttachment，但实际返回econtractAttachment，这里做兼容处理
        const { econtractAttachment, eContractAttachment } = contractDetail;
        if (econtractAttachment || eContractAttachment) {
          this.isHasContractFile = true;
        }
      } else {
        // 2 纸质合同
        // :bizId="contractId" bizType="crm.contract"
        const bizId = this.contractId;
        const bizType = 'crm.contract';
        if (!bizId || !bizType) {
          return;
        }
        this.$getJSON(`${apis.OssAttach}/${bizId}/${bizType}`).then((res) => {
          const list = res.data;
          if (list.length > 0) {
            this.isHasContractFile = true;
          }


        });
      }
    },
    // 下载电子合同
    download(contractDetail) {
      if (`${contractDetail.signingMethod}` === '1') {
        // 电子合同
        // econtractAttachment: "http://ice-i-synergy.oss-cn-shenzhen.aliyuncs.com/bestSign/2021-07-26/162726616701000001.pdf"
        // 接口返回字段定义为eContractAttachment，但实际返回econtractAttachment，这里做兼容处理
        const { econtractAttachment, eContractAttachment } = contractDetail;
        this.jumpOutside(econtractAttachment || eContractAttachment, true);
        if (econtractAttachment || eContractAttachment) {
          this.jumpOutside(econtractAttachment || eContractAttachment, true);
        } else {
          this.$message({
            message: this.$t('contract_detail_dzhtqs'),
            type: 'error'
          });
        }
      } else {
        // 2 纸质合同
        // :bizId="contractId" bizType="crm.contract"
        const bizId = this.contractId;
        const bizType = 'crm.contract';
        if (!bizId || !bizType) {
          return;
        }
        this.$getJSON(`${apis.OssAttach}/${bizId}/${bizType}`).then((res) => {
          const list = res.data;
          if (list.length > 0) {
            this.jumpOutside(this.getAttachUrl(list[0]), true);
          } else {
            this.$message({
              message: this.$t('contract_detail_htfjqs'),
              type: 'error'
            });
          }


        });
      }

    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.contract-detail-bd {
  padding: 24px 24px 56px;
  .container {
    padding: 24px;
    background: #ffffff;
    border-radius: 16px;
    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 40px;
      color: $--color-text-regular;
      padding-bottom: 24px;
      border-bottom: 1px solid rgba(0, 160, 217, 0.16);
    }

    .status {
      padding-top: 24px;
      color: $--color-text-secondary;
      font-weight: bold;
      font-size: 16px;
      line-height: 40px;
      span {
        font-weight: bold;
        font-size: 16px;
        margin-left: 5px;
        color: $--color-primary;
        i {
          width: 8px;
          height: 8px;
          display: inline-block;
          margin-right: 8px;

          background-color: $--color-primary;
          border-radius: 50%;
        }
      }

      .download {
        margin-left: auto;
        width: 40px;
        height: 40px;
        font-size: 14px;
        border: 1.5px solid $--color-text-primary;
        border-radius: 50%;
        color: $--color-text-primary;
        text-align: center;
        cursor: pointer;
      }
    }
    .introduction {
      padding-top: 24px;
      display: flex;
      li {
        height: 74px;
        padding-left: 24px;
        flex: 1;
        background: #ffffff;
        border: 1px solid #f0f0f0;
        border-radius: 16px;
        flex-grow: 1;
        margin-right: 24px;
        display: flex;
        align-items: center;
        &:last-child {
          margin: 0;
        }
        .icon {
          font-size: 36px;
          color: $--color-primary;
          margin-right: 16px;
        }
        .text {
          width: 0;
          flex: 1;
          overflow: hidden;

          .key {
            font-weight: bold;
            font-size: 12px;
            line-height: 150%;
            color: $--color-text-secondary;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .name {
            font-size: 14px;
            line-height: 140%;
            color: $--color-text-regular;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .info {
      margin-top: 24px;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #f0f0f0;
      .line {
        font-weight: bold;
        font-size: 18px;
        line-height: 40px;
        color: $--color-text-primary;
        display: flex;
        justify-content: space-between;
        .action {
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          color: #818181;
          i {
            font-size: 12px;
            color: $--color-text-primary;
          }
        }
      }
      .info-box {
        margin-top: 24px;
        display: flex;
        li {
          width: 0;
          flex: 1;
          padding: 24px;
          border: 1px solid #f5f5f5;
          border-radius: 16px;
          margin-right: 16px;
          &:last-child {
            margin-right: 0px;
          }
          h4 {
            font-weight: bold;
            font-size: 12px;
            line-height: 17px;
            color: $--color-primary;
            margin-bottom: 16px;
          }
          .key {
            font-weight: bold;
            font-size: 12px;
            line-height: 140%;
            margin-bottom: 8px;
            color: $--color-text-secondary;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            .val {
              margin-left: 16px;
              font-weight: bold;
              font-size: 12px;
              line-height: 140%;
              color: $--color-text-regular;
            }
          }
        }
      }
    }
    .device {
      margin-top: 24px;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid #f0f0f0;
      .el-tabs .el-tabs__item {
        font-size: 12px;
      }
      .line {
        font-weight: bold;
        font-size: 18px;
        line-height: 40px;
        color: $--color-text-primary;
        display: flex;
        justify-content: space-between;
        .action {
          cursor: pointer;
          font-weight: bold;
          font-size: 12px;
          color: #818181;
          i {
            font-size: 12px;
            color: $--color-text-primary;
          }
        }
      }

      .tab-box {
        margin-top: 24px;
      }
      // 表格
      .table-bd {
        width: 100%;
        // 表头
        .table-head {
          height: 40px;
          line-height: 40px;
          display: flex;
          background-color: #fff;
          // border-radius: 16px;
          box-shadow: inset 0px -1px 0px #f0f0f0;
          li {
            padding-left: 10px;
            // text-align: center;
            color: $--color-text-secondary;
            box-sizing: border-box;
            flex: 2;
            width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              font-weight: bold;
              font-size: 14px;
              color: $--color-text-secondary;
            }
            &.product {
              flex: 2;
            }
          }
        }
        // 内容
        .table-body {
          font-size: 0;
           &>li{
             font-size: 0;
          }
          // height: 80px;
          // line-height: 80px;

          // align-content: center;
          .content {
            cursor: pointer;
            // margin-top: 16px;
            height: 64px;
            line-height: 64px;
            display: flex;
            // flex-direction: column;
            background-color: #fff;
            border-radius: 16px;
            align-content: center;
            li {
              box-sizing: border-box;
              padding-left: 10px;
              color: $--color-text-secondary;
              flex: 2;
              width: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              // text-align: center;
              span {
                color: $--color-text-regular;
                font-size: 14px;
              }
              &.product {
                flex: 2;
                padding-bottom: 0;
                display: flex;
                align-items: center;
                img {
                  max-width: 40px;
                  max-height: 40px;
                  border-radius: 8px;
                  display: inline-block;
                }
              }
            }
          }
          // 无数据
          .no-data {
            margin-top: 24px;
            height: 130px;
            text-align: center;
            line-height: 130px;
            font-size: 16px;
            color: #818181;
            background: #ffffff;
            border-radius: 16px;
          }
        }
        // 列占比
        // .site {
        //   width: 0;
        //   flex: 4;
        //   .site-info {
        //     padding-left: 25px;
        //     height: 80px;
        //     display: flex;
        //     align-items: center;
        //     font-size: 0;
        //     i {
        //       color: $--color-success;
        //       font-size: 22px;
        //       margin-right: 18px;
        //     }
        //     .text {
        //       align-self: center;
        //       display: flex;
        //       // align-items: center;
        //       flex-direction: column;
        //       p {
        //         font-weight: bold;
        //         font-size: 14px;
        //         line-height: 20px;
        //         color: $--color-text-regular;
        //       }
        //       span {
        //         font-size: 12px;
        //         line-height: 17px;
        //         text-align: left;
        //         color: $--color-text-secondary;
        //       }
        //     }
        //   }
        //   // width: 330px;
        // }
        // .area {
        //   width: 0;
        //   flex: 3;
        //   text-align: left !important;
        // }
        // .duration {
        //   width: 0;
        //   flex: 3;
        //   text-align: left !important;
        // }
        // .num {
        //   width: 0;
        //   flex: 1;
        //   text-align: center;
        //   padding: 0 !important;
        //   margin-right: 30px;
        // }
      }
      .table-footer {
        margin-top: 16px;
      }
    }
  }
}
</style>
